import { Component, OnInit } from '@angular/core'
import { select, Store } from '@ngrx/store'
import { selectWebsitesByType } from '@tv3/store/website/website.selectors'
import { FormBuilder, Validators } from '@angular/forms'
import { startWith } from 'rxjs/operators'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { Toaster } from '@tokeet-frontend/tv3-platform'
import { widgetFontFamilies } from '@tv3/containers/widgets/shared/constants/font-families'
import { WebsiteTypes } from '@tv3/store/website/website.model'
import { AmplitudeService } from '@tv3/services/amplitude.service'

@Component({
  selector: 'app-search-widget',
  templateUrl: './search-widget.component.html',
  styleUrls: ['./search-widget.component.scss'],
})
export class SearchWidgetComponent implements OnInit {
  widgetCode = ''
  trustedWidgetCode: SafeHtml
  fontSizeOpts = [12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24]
  fontFamilies = widgetFontFamilies
  orientationOpts = ['vertical', 'horizontal']

  form = this.fb.group({
    website: [undefined],
    background: ['#f8f8f8', [Validators.required]],
    button_bg: ['#00bcd3', [Validators.required]],
    button_fg: ['#fff', [Validators.required]],
    blocked_bg: ['#b63e3e', [Validators.required]],
    label_bg: ['#00bcd3', [Validators.required]],
    selected_bg: ['#299082', [Validators.required]],
    selected_fg: ['#fff', [Validators.required]],
    font: ['Arial', [Validators.required]],
    label_px: [14, [Validators.required]],
    orientation: ['vertical', [Validators.required]],
    sundayFirst: [true, [Validators.required]],
    width: [350, [Validators.required]],
  })

  websites$ = this.store.pipe(select(selectWebsitesByType, { type: WebsiteTypes.RentalWebsite }))

  constructor(
    private store: Store<any>,
    private fb: FormBuilder,
    private toast: Toaster,
    private sanitizer: DomSanitizer,
    private amplitudeService: AmplitudeService
  ) {}

  ngOnInit() {
    this.form.valueChanges.pipe(startWith(this.form.getRawValue())).subscribe((config) => {
      this.buildCode(config)
    })
  }

  buildCode(config) {
    if (!config.website) {
      return
    }
    this.widgetCode = `<div style="width:${config.width}px"
         data-tokeet-widget="availability-search"
         data-website-domain="https://${config.website.domain}"
         data-orientation="${config.orientation}"
         data-style-widget-background="${config.background}"
         data-style-button-bg="${config.button_bg}"
         data-style-button-color="${config.button_fg}"
         data-style-label-color="${config.label_bg}"
         data-style-label-size="${config.label_px}"
         data-style-selected-dates-bg="${config.selected_bg}"
         data-style-selected-dates-color="${config.selected_fg}"
         data-booking-widget-css=".booking-widget { font-family: ${config.font} }"
        class="availability-search-widget"></div>
        <script data-tokeet-widget-loader="availability-search"
        src="https://s3.amazonaws.com/widgets.tokeet.com/widgets/availability/loader.js"></script>`
    this.trustedWidgetCode = this.sanitizer.bypassSecurityTrustHtml(this.widgetCode)
  }

  onCopied($event) {
    this.toast.success($localize`Code copied.`)
    this.amplitudeService.logEvent('widget-search-copied')
  }

  onColorSelected(key, color) {
    this.form.patchValue({ [key]: color })
  }
}
